module.exports = __webpack_public_path__ + "img/ALLERGIC_DOG.9688c97a.svg";